var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('baseBreadcrumb',{attrs:{"page":_vm.$t('message.porderWaitPaySubmit'),"menu":_vm.$t('message.porder')}}),_c('porderBaseTable',{attrs:{"status":30}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }